import { TransactionJsonModel, TransactionVariableJsonModel } from '../../domain/stream/transaction/TransactionDomains';
import { CaseGraphField, GraphDefaultFilter } from '../../domain/case/CaseDomains';
import { FormicaSelectBoxItem } from '../../components/custom/FormicaSearchSelectBox';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { GraphAction } from '../actions/GraphActions';
import { GraphInformationJsonModel } from '../../domain/graph/GraphDomains';
import { SuspiciousActivityReport } from '../../domain/case/SuspiciousActivityReport';

export type TransactionState = Pick<TransactionJsonModel, 'id' | 'name' | 'variables'>;

export interface CaseGraphFieldState {
  _id: string;
  name: string;
  graphConfiguration: CaseGraphField[];
  transactionCurrencyField: string;
  transactionAmountField: string;
  suspiciousActivityReport: SuspiciousActivityReport;
  graphDefaultFilterRequired: boolean;
  graphDefaultFilter: GraphDefaultFilter;
  variables: Array<TransactionVariableJsonModel>;
}

export interface GraphState {
  transactions: TransactionState[];
  caseGraphFields: CaseGraphFieldState | undefined;
  selectedFields: FormicaSelectBoxItem[];

  loading: boolean;
  isGraphLoading: boolean;

  nodeLimit: number;
  selectedTransaction: string;
  response: any;

  selectedNode: GraphInformationJsonModel | undefined;
  informationVisible: boolean;
  informationCoordinates: { x: number; y: number };

  update: number;
}

const initialState: GraphState = {
  transactions: [],
  caseGraphFields: undefined,
  selectedFields: [],
  loading: true,
  isGraphLoading: false,
  nodeLimit: 20,
  selectedTransaction: '',
  response: undefined,
  selectedNode: undefined,
  informationVisible: false,
  informationCoordinates: { x: 0, y: 0 },
  update: 0,
};

export const graphReducer = (state: GraphState = initialState, action: ReduxBaseAction<any, GraphAction>) => {
  switch (action.type) {
    case 'CHANGE_GRAPH_FIELDS': {
      return {
        ...state,
        caseGraphFields: action.payload,
      };
    }
    case 'CHANGE_SELECTED_FIELDS': {
      return {
        ...state,
        selectedFields: action.payload,
      };
    }
    case 'CHANGE_LOADING': {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case 'CHANGE_GRAPH_LOADING': {
      return {
        ...state,
        isGraphLoading: action.payload,
      };
    }
    case 'CHANGE_NODE_LIMIT': {
      return {
        ...state,
        nodeLimit: action.payload,
      };
    }
    case 'CHANGE_SELECTED_TRANSACTION': {
      return {
        ...state,
        selectedTransaction: action.payload,
      };
    }
    case 'CHANGE_GRAPH_RESPONSE': {
      return {
        ...state,
        response: action.payload,
      };
    }
    case 'CHANGE_SELECTED_NODE': {
      return {
        ...state,
        selectedNode: action.payload,
      };
    }
    case 'CHANGE_INFORMATION_VISIBLE': {
      return {
        ...state,
        informationVisible: action.payload,
      };
    }
    case 'CHANGE_INFORMATION_COORDINATES': {
      return {
        ...state,
        informationCoordinates: action.payload,
      };
    }
    case 'CHANGE_TRANSACTIONS': {
      return {
        ...state,
        transactions: action.payload,
      };
    }
    case 'CHANGE_UPDATE': {
      return {
        ...state,
        update: action.payload,
      };
    }
    case 'CLEAR_GRAPH': {
      return {
        ...state,
        transactions: [],
        caseGraphFields: undefined,
        selectedFields: [],
        loading: true,
        isGraphLoading: false,
        nodeLimit: 20,
        selectedTransaction: '',
        response: undefined,
        selectedNode: undefined,
        informationVisible: false,
        informationCoordinates: { x: 0, y: 0 },
        update: 0,
      };
    }
    default:
      return state;
  }
};
